<template>
  <div class="page">
    <el-form ref="form" :model="formData">
      <div class="contain">
        <div class="title">询比价查看权限设置</div>
        <el-form-item prop="inquirySheetLook">
          <el-radio-group v-model="formData.inquirySheetLook">
            <el-radio label="10">所有询价单</el-radio>
            <el-radio label="20">仅查看下单人询价单</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="remrk">
          <div>注：1、所有询价单： 支持企业下的账号互相查看询价单</div>
          <div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、仅查看下单人询价单：仅下单人查看自己的询价单，无法查看企业内其他人员的询价单，采购商管理员可以查看所有询价单。
          </div>
        </div>
      </div>
      <div class="contain">
        <div class="title">询比价操作权限设置</div>
        <el-form-item prop="inquirySheetOperate">
          <el-radio-group v-model="formData.inquirySheetOperate" :disabled="formData.inquirySheetLook === '20'">
            <el-radio label="11">支持互相操作</el-radio>
            <el-radio label="12">仅支持下单人操作</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="remrk">
          <div>
            注：1、支持互相操作：支持企业下的账号互相操作询价单，包括撤回、回退、选商定价、延时、作废、编辑、删除、重新询价等；
          </div>
          <div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、仅支持下单人操作：仅支持下单人操作自己的询价单，不可操作其他人的询价单，采购商管理员可以操作所有的询价单。
          </div>
        </div>
      </div>

      <div class="contain">
        <div class="title">询比价报价供应商查看权限设置</div>
        <el-form-item prop="inquirySheetOperate">
          <el-radio-group v-model="data" @change="savePriceSupplierConfig">
            <el-radio label="131">支持查看报价供应商</el-radio>
            <el-radio label="132">不支持查看报价供应商</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="remrk">
          <div>注：设置询价企业采购人员是否能查看到报价供应商名称。</div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/enquiry';

export default {
  name: 'EnquiryAuth',
  data() {
    return {
      formData: {
        inquirySheetLook: '',
        inquirySheetOperate: '',
      },
      data: '',
    };
  },
  watch: {
    formData: {
      deep: true,
      immediate: true,
      handler(newval, oldval) {
        if (oldval.inquirySheetLook) {
          this.handleSubmit();
        }
      },
    },
  },
  mounted() {
    this.fetchInit();
    this.getQueryPriceSupplierConfig();
  },
  methods: {
    fetchInit() {
      api.getInquirySheetConfig().then((res) => {
        if (res.success) this.formData = res.data;
      });
    },
    handleSubmit() {
      api.addInquirySheetConfig(this.formData).then((res) => {
        if (res.success) this.$message.success('修改成功');
      });
    },
    getQueryPriceSupplierConfig() {
      api.queryPriceSupplierConfig().then((res) => {
        console.log('res:', res);
        this.data = res.data?.data || '131';
      });
    },

    savePriceSupplierConfig(val) {
      const params = { data: val };
      api.savePriceSupplierConfig(params).then((res) => {
        if (res.success) this.$message.success('修改成功');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .contain {
    padding: 20px;
    background: #fff;
    margin-bottom: 20px;
  }

  .title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 40px;
  }

  .remrk {
    background: #e8efff;
    padding: 20px;
    margin: 20px 0px;

    div {
      white-space: nowrap;
      font-size: 16px;
    }
  }
  .submit_btn {
    margin: 20px auto 0;
    cursor: pointer;
    width: 80px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2587ff;
    color: #fff;
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
}
</style>
